import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import SimpleBar from "simplebar-react";
import App from "./App";

import "simplebar-react/dist/simplebar.min.css";
import "./index.css";

document.addEventListener("dragstart", (e) => {
  const target = e.target;

  if (
    target.tagName === "IMG" ||
    target.tagName === "A" ||
    target.tagName === "BUTTON" ||
    target.closest("a") ||
    target.closest("button")
  ) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SimpleBar
      id="outfall-scroll-root"
      style={{ maxHeight: "100vh" }}
      scrollableNodeProps={{
        onScroll: (e) => {
          const el = e.currentTarget;
          const maxScroll = el.scrollHeight - el.clientHeight;
          const progress = maxScroll > 0 ? el.scrollTop / maxScroll : 0;

          let headerOpacity = 1;
          let middleOpacity = 0;
          let footerOpacity = 0;

          if (progress > 0.12 && progress < 0.82) {
            headerOpacity = 0;
            middleOpacity = 1;
            footerOpacity = 0;
          }

          if (progress >= 0.82) {
            headerOpacity = 0;
            middleOpacity = 0;
            footerOpacity = 1;
          }

          document.documentElement.style.setProperty(
            "--scrollbar-header-opacity",
            headerOpacity,
          );

          document.documentElement.style.setProperty(
            "--scrollbar-middle-opacity",
            middleOpacity,
          );

          document.documentElement.style.setProperty(
            "--scrollbar-footer-opacity",
            footerOpacity,
          );
        },
      }}
    >
      <App />
    </SimpleBar>
  </BrowserRouter>,
);
